module.exports = "./img/maintenance.6528afb.jpg";